import React from 'react';
import { useTheme } from '@material-ui/core';
import FormML from './FormML';
import StepThreeStyled from './StepThreeMLStyles';

export default (props) => {
  const theme = useTheme();
  return (
    <StepThreeStyled theme={theme}>
      <FormML {...props} />
    </StepThreeStyled>
  );
};
